import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps,PrismicRichText } from "@prismicio/react";
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next'

/**
 * Props for `Help`.
 */
export type HelpProps = SliceComponentProps<Content.HelpSlice>;

/**
 * Component for "Help" Slices.
 */
const Help: FC<HelpProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation} 
      className="font-fellix bg-lightjade py-16 px-4 md:px-8 lg:px-12 xl:px-0"
    >
      <div className="max-w-[1280px] mx-auto text-center">
        <PrismicNextImage field={slice.primary.icon} fallbackAlt="" className="mx-auto"/>
        <article className="prose prose-h4:font-normal prose-h4:text-[24px] prose-h4:m-0 prose-h4:mb-8 prose-h4:leading-[28px] prose-strong:font-semibold max-w-[700px] mx-auto my-16">
          <PrismicRichText field={slice.primary.text}/>
        </article>
        <ul className="md:flex justify-center gap-x-6 max-w-[700px] mx-auto">
          {slice.primary.links.map((item: any, index: number)=>{
            if(item.button_link) {
              return (
                <li className="mb-4 " key={index}>
                  <PrismicNextLink field={item.button_link} className="jade-hollow">
                    {item.button_text}
                  </PrismicNextLink>
                  </li>
                )
            }
            else return null
          })}
        </ul>
      </div>
    </section>
  );
};

export default Help;
